import Slider from 'components/Customs/Carousel/Slider'
import PanelInfo from 'components/Customs/Panels/PanelInfo'
import PanelInformation from 'components/Customs/CardVehicle/PanelInformation'
import ShareNetworks from 'components/Customs/CardVehicle/ShareNetworks'

import { SwiperSlide } from 'swiper/react'

const PanelDetailCarSalfa = ({ item, addCompareCar, viewCar, handleQuoteCar, goToConcesionaire }) => {
    console.log(item)
    console.log(item?.nombreMarca)
    const isCompare= false;
    return (
        <PanelInfo isClassCard="border-0 mt-5" isClassBody="padding-body">
            <section className="result-details">
                <ShareNetworks
                    id={item.idauto}
                    isMyRouter={false}
                    idKey={item.idauto}
                    title={item.nombreMarca}
                    photo={item.fotos}
                    type="autos"
                />
                <section className="container-info-row">
                    <div className="result-details__slide">
                        <div className="slide-car" onClick={() => viewCar(item.idauto)}>
                            <Slider
                                options={{
                                    className: "slider-car--height",
                                    navigation: false,
                                    slidesPerView: 1,
                                    slidesPerColumn: 1,
                                    spaceBetween: 1,
                                    pagination: false,
                                }}
                            >
                                {item.fotos.map((car, key) => {
                                    const imgSrc = car && car.trim() !== '' ? car : '/logos/thumbs-1.png';

                                    return (
                                        <SwiperSlide key={key}>
                                            <div className="result-details__image">
                                                <img
                                                    src={imgSrc}
                                                    alt={item.nombreMarca || `auto-${item.idauto}`}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = '/logos/thumbs-1.png'; // Asegúrate de que esta imagen exista
                                                    }}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Slider>
                        </div>
                    </div>



                    <div className="info-car__view">

                        <div className="result-info__top">
                            <PanelInformation
                                type={"Usado"}
                                name={`${item.year} ${item.nombreMarca} ${item.nombreModelo}`}
                                price={item.precio}
                                infoBrand={"Autos Usados"}
                                isVisibleShare={false}
                                mileage={item.kms}
                                transmission={item.transmisionNombre}
                                fuel={item.combustibleNombre}
                                classMain="info-car__description infor-car__result"
                                viewCar={viewCar}
                                id={item.idauto}
                                typeKey={item.idauto}
                                goToConcesionaire={"salfa-usados"}
                                listPrice={item?.precio}
                                priceLockDown={`${item?.moneda} ${new Intl.NumberFormat('es-CL').format(item?.precio)}`}
                                listPriceView={new Intl.NumberFormat('es-CL').format(item?.precio)}
                                idKey={item.idauto}
                                status_id={"1"}
                                stock={true}
                                consesionaire={"salfa-usados"}
                            />
                        </div>
                        <div className="result-footer w-100">
                            <div className="w-100">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg w-100"
                                    onClick={() => handleQuoteCar(item.idauto, "")}
                                >Cotizar</button>
                            </div>
                            <div className="result-footer__comparar">
                                <div className="search-form">
                                    <input
                                        className="search-form-check search-form-check--orange"
                                        type="checkbox"
                                        defaultChecked={isCompare}
                                        id={item.idauto}
                                        name="isCompare[]"
                                        onChange={(event) => addCompareCar(event, item.idauto)}
                                    />
                                    <label className="marca-form-label" htmlFor={item.idauto}>
                                        Comparar
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </section>
        </PanelInfo>
    )
}

export default PanelDetailCarSalfa
